export default __webpack_public_path__ + "static/media/green-tick.83373d1f.svg";